import { object, string, date } from 'yup';

const dealEventSchema = object({
  id: string(),
  created_on: date().required(),
  updated_on: date().required(),
  deal_id: string().required(),
  company_id: string().required(),
  type: string().required(),
  data: object().nullable(),
  created_by: string().nullable(),
});

export default dealEventSchema;
